import ModalTitleComponent, {
	SecondaryItem,
	SecondaryItemType,
	ModalTitleComponentProps,
} from './ModalTitleComponent';
export { SecondaryItemType };
export type { SecondaryItem, ModalTitleComponentProps };
export default ModalTitleComponent;
